import { render, staticRenderFns } from "./formEnclosure.vue?vue&type=template&id=70c8b006&scoped=true"
import script from "./formEnclosure.vue?vue&type=script&lang=js"
export * from "./formEnclosure.vue?vue&type=script&lang=js"
import style0 from "./formEnclosure.vue?vue&type=style&index=0&id=70c8b006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8b006",
  null
  
)

export default component.exports